import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, FileText, Package, ShoppingCart, Users, Settings, LogOut, Webhook, BarChart, Quote, HelpCircle, Globe, BookOpen, Share2, Printer, Gift, Briefcase, Mail, Warehouse, TrendingUp } from 'lucide-react';

const AdminLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    { path: '/admin', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/admin/analytics', icon: BarChart, label: 'Analytics' },
    { path: '/admin/revenue', icon: TrendingUp, label: 'Revenue' },
    { path: '/admin/inventory', icon: Warehouse, label: 'Inventory & Margins' },
    { path: '/admin/publications', icon: FileText, label: 'Publications' },
    { path: '/admin/packages', icon: Package, label: 'Packages' },
    { path: '/admin/social-pages', icon: Share2, label: 'Social Pages' },
    // { path: '/admin/print-media', icon: Printer, label: 'Print Media' },  // TEMPORARILY HIDDEN
    { path: '/admin/bundles', icon: Gift, label: 'Bundles' },
    { path: '/admin/orders', icon: ShoppingCart, label: 'Orders' },
    { path: '/admin/customers', icon: Users, label: 'Customers' },
    { path: '/admin/partners', icon: Briefcase, label: 'Partners' },
    { path: '/admin/campaigns', icon: Mail, label: 'Email Campaigns' },
    { path: '/admin/blogs', icon: BookOpen, label: 'Insights/Blog' },
    { path: '/admin/testimonials', icon: Quote, label: 'Testimonials' },
    { path: '/admin/faqs', icon: HelpCircle, label: 'FAQs' },
    { path: '/admin/site-settings', icon: Globe, label: 'Site Settings' },
    { path: '/admin/webhook', icon: Webhook, label: 'Webhook Config' },
    { path: '/admin/settings', icon: Settings, label: 'Settings' },
  ];

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/admin/login');
  };

  const isActive = (path) => {
    if (path === '/admin') {
      return location.pathname === '/admin';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="flex min-h-screen grain">
      <aside className="w-64 bg-black text-white flex flex-col">
        <div className="p-6 border-b border-gray-800">
          <h1 className="font-playfair text-xl font-bold">Admin Panel</h1>
        </div>
        
        <nav className="flex-1 p-4">
          <ul className="space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              return (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    data-testid={`admin-nav-${item.label.toLowerCase()}`}
                    className={`flex items-center gap-3 px-4 py-3 font-manrope text-sm transition-all duration-300 ${
                      isActive(item.path)
                        ? 'bg-white text-black'
                        : 'hover:bg-gray-800'
                    }`}
                  >
                    <Icon className="w-5 h-5" />
                    {item.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
        
        <div className="p-4 border-t border-gray-800">
          <button
            onClick={handleLogout}
            data-testid="admin-logout-button"
            className="flex items-center gap-3 px-4 py-3 w-full font-manrope text-sm hover:bg-gray-800 transition-all duration-300"
          >
            <LogOut className="w-5 h-5" />
            Logout
          </button>
        </div>
      </aside>
      
      <main className="flex-1 bg-white">
        <div className="p-6 md:p-12">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;